/* eslint-disable @typescript-eslint/no-unused-vars */
// TECH DEBT: pull these values from backend config in app.blade.php
export const STATUS_COMPLETED = 'completed';
export const STATUS_ACTIVE = null;

// TECH DEBT: pull these values from backend config in app.blade.php
export const TASK_PRIORITY_URGENT = 'urgent';
export const TASK_PRIORITY_HIGH = 'high';
export const TASK_PRIORITY_MEDIUM = 'medium';
export const TASK_PRIORITY_LOW = 'low';
export const TASK_PRIORITY_NONE = null;
